/* HEARTEATERR333 theme scripts — no dependencies. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); }

  function define(name, constructor) {
    if (!customElements.get(name)) customElements.define(name, constructor);
  }

  function storageGet(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }

  function storageSet(store, key, value) {
    try { window[store].setItem(key, value); } catch (e) { /* storage unavailable */ }
  }

  function pad(number) { return number < 10 ? '0' + number : String(number); }

  /* ---------- Money ---------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || theme.moneyFormat || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ');
        default: return withDelimiters(cents, 2);
      }
    });
  }

  /* ---------- Toast ---------- */

  var toastTimer;
  function toast(message, type) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.dataset.type = type || '';
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 2600);
  }

  /* ---------- Header height (used by sticky gallery & full-height hero) ---------- */

  function setHeaderHeight() {
    var bar = $('.site-header__bar');
    if (!bar) return;
    var announcement = $('announcement-bar:not([hidden])');
    var height = bar.offsetHeight + (announcement ? announcement.offsetHeight : 0);
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }

  window.addEventListener('resize', setHeaderHeight);

  /* ---------- Announcement bar ---------- */

  define('announcement-bar', class extends HTMLElement {
    connectedCallback() {
      var key = this.dataset.dismissKey;
      if (!designMode && storageGet('sessionStorage', key) === '1') this.hidden = true;

      var button = this.querySelector('[data-dismiss]');
      if (button) {
        button.addEventListener('click', () => {
          storageSet('sessionStorage', key, '1');
          this.hidden = true;
          setHeaderHeight();
        });
      }
      setHeaderHeight();
    }
  });

  /* ---------- Header ---------- */

  define('site-header', class extends HTMLElement {
    connectedCallback() {
      this.menuButton = this.querySelector('[data-menu-toggle]');
      this.menu = this.querySelector('.mobile-menu');
      this.searchButton = this.querySelector('[data-search-toggle]');
      this.search = this.querySelector('.site-header__search');

      if (this.menuButton) {
        this.menuButton.addEventListener('click', () => {
          this.toggle(this.search, this.searchButton, false);
          this.toggle(this.menu, this.menuButton);
        });
      }

      if (this.searchButton) {
        this.searchButton.addEventListener('click', () => {
          this.toggle(this.menu, this.menuButton, false);
          var open = this.toggle(this.search, this.searchButton);
          if (open) {
            var input = this.search.querySelector('input[type="search"]');
            if (input) input.focus();
          }
        });
      }

      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        this.toggle(this.menu, this.menuButton, false);
        this.toggle(this.search, this.searchButton, false);
      };
      document.addEventListener('keydown', this.onKeydown);
      setHeaderHeight();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    toggle(panel, button, force) {
      if (!panel || !button) return false;
      var open = force === undefined ? panel.hidden : force;
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.classList.toggle('is-open', open);
      return open;
    }
  });

  /* ---------- Cart ---------- */

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
    });
  }

  function jsonOrThrow(response) {
    return response.json().then(function (data) {
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || theme.strings.cartError);
      }
      return data;
    });
  }

  define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }
        var change = event.target.closest('[data-cart-change]');
        if (change) {
          this.change(change.dataset.line, change.dataset.quantity);
          return;
        }
        if (event.target.closest('[data-cart-clear]')) this.clear();
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      };
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    open() {
      this.previousFocus = document.activeElement;
      this.classList.add('is-open');
      document.documentElement.classList.add('scroll-lock');
      var panel = this.querySelector('.cart-drawer__panel');
      if (panel) setTimeout(function () { panel.focus(); }, 50);
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('scroll-lock');
      if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus();
    }

    render(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = this.querySelector('[data-cart-drawer-inner]');
      if (!fresh || !current) return;
      current.replaceWith(fresh);
      updateCartCount(fresh.dataset.itemCount || 0);
    }

    change(line, quantity) {
      this.classList.add('is-loading');
      return fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(line),
          quantity: Math.max(0, Number(quantity)),
          sections: ['cart-drawer'],
          sections_url: window.location.pathname
        })
      })
        .then(jsonOrThrow)
        .then((cart) => {
          if (cart.sections) this.render(cart.sections['cart-drawer']);
          else return this.reload();
        })
        .catch(function (error) { toast(error.message, 'error'); })
        .finally(() => this.classList.remove('is-loading'));
    }

    clear() {
      this.classList.add('is-loading');
      return fetch(theme.routes.cartClear + '.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(() => this.reload())
        .catch(function (error) { toast(error.message, 'error'); })
        .finally(() => this.classList.remove('is-loading'));
    }

    reload() {
      var root = theme.routes.root || '/';
      var url = root + (root.indexOf('?') === -1 ? '?' : '&') + 'sections=cart-drawer';
      return fetch(url)
        .then(function (response) { return response.json(); })
        .then((sections) => this.render(sections['cart-drawer']));
    }
  });

  function getDrawer() {
    if (theme.cartType !== 'drawer' || theme.template === 'cart') return null;
    return $('cart-drawer');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-open]');
    if (!trigger) return;
    var drawer = getDrawer();
    if (!drawer) return;
    event.preventDefault();
    drawer.open();
  });

  function addToCart(form) {
    var formData = new FormData(form);
    // The option radios only drive the variant picker; Shopify just needs the variant id.
    Array.from(formData.keys()).forEach(function (key) {
      if (key.indexOf('option-') === 0) formData.delete(key);
    });
    var drawer = getDrawer();
    if (drawer) {
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
    }
    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(jsonOrThrow);
  }

  function refreshCartCount() {
    return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---------- Color swatch fallback (ported from the original colorSwatch.ts) ---------- */

  var MULTI = 'conic-gradient(from 0deg,#e8702a,#c0291f,#5e2a8a,#1f7a7a,#2e7d4f,#f0c63a,#e8702a)';
  var COLOR_MAP = {
    black: '#0a0a0a', white: '#f8f8f6', cream: '#f1ebde', ivory: '#f5f1e6', bone: '#e8e2d2',
    offwhite: '#efece4', 'off-white': '#efece4', natural: '#e6dcc6', sand: '#d9c9a8', tan: '#c9a87a',
    beige: '#d8c9ad', khaki: '#9b8a5a', brown: '#5b3a22', chocolate: '#3b2418', mocha: '#6b4a32',
    coffee: '#4b2e1f', gray: '#808080', grey: '#808080', charcoal: '#36393e', silver: '#c0c0c0',
    stone: '#9a8e7e', red: '#c0291f', maroon: '#5a0f15', burgundy: '#5e1a25', crimson: '#a01b25',
    pink: '#f0a8b8', hotpink: '#ff4d8a', 'hot-pink': '#ff4d8a', blush: '#f3c8c8', rose: '#d77a8a',
    orange: '#e8702a', rust: '#9a4520', yellow: '#f0c63a', mustard: '#c89b2a', gold: '#c9a84c',
    green: '#2e7d4f', olive: '#5b6a2a', sage: '#a8b89a', forest: '#1f3a2a', mint: '#a8e0c5',
    lime: '#b8e02a', teal: '#1f7a7a', blue: '#2a52c7', navy: '#0f1b3d', royal: '#1a3aa8',
    sky: '#7dc9f0', denim: '#3a5a8a', purple: '#5e2a8a', violet: '#6a3aa8', lavender: '#c8b8e0',
    lilac: '#b8a8d8', multi: MULTI, multicolor: MULTI, rainbow: MULTI,
    camo: 'linear-gradient(135deg,#5b6a2a 25%,#3b4a1a 25% 50%,#9b8a5a 50% 75%,#5b3a22 75%)'
  };

  function colorToCss(value) {
    var lower = value.toLowerCase();
    var key = lower.replace(/\s+/g, '').replace(/[^a-z-]/g, '');
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    var first = lower.split(/\s+/)[0];
    if (COLOR_MAP[first]) return COLOR_MAP[first];
    var hash = 0;
    for (var i = 0; i < value.length; i++) hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
    return 'hsl(' + (hash % 360) + ' 30% 55%)';
  }

  function paintSwatches(context) {
    $$('[data-swatch-fallback]', context).forEach(function (swatch) {
      var css = colorToCss(swatch.dataset.swatchFallback || '');
      if (css.indexOf('gradient') !== -1) swatch.style.backgroundImage = css;
      else swatch.style.backgroundColor = css;
    });
  }

  /* ---------- Product page ---------- */

  define('product-info', class extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-product-json]');
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = this.querySelector('[data-product-form]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.addButton = this.querySelector('[data-add-button]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.priceEl = this.querySelector('[data-price]');
      this.soldOutEl = this.querySelector('[data-soldout]');
      this.dynamicCheckout = this.querySelector('[data-dynamic-checkout]');
      this.fieldsets = $$('[data-option]', this);

      paintSwatches(this);
      this.initGallery();
      this.initBackLink();
      this.updateAvailability();

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) this.onOptionChange(event.target);
      });

      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    initBackLink() {
      var back = this.querySelector('[data-back-link]');
      if (!back) return;
      back.addEventListener('click', function (event) {
        var sameOrigin = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
        if (sameOrigin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      });
    }

    /* Gallery */

    initGallery() {
      this.slides = $$('.product__slide', this);
      this.thumbs = $$('[data-thumb]', this);
      this.counter = this.querySelector('[data-counter-current]');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showSlide(Number(thumb.dataset.index)));
      });

      var stage = this.querySelector('.product__stage');
      if (stage && this.slides.length > 1) {
        var startX = null;
        stage.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', (event) => {
          if (startX === null) return;
          var delta = event.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) this.showSlide(this.activeIndex() + (delta < 0 ? 1 : -1));
          startX = null;
        });
      }
    }

    activeIndex() {
      var index = this.slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
      return index < 0 ? 0 : index;
    }

    showSlide(index) {
      var count = this.slides.length;
      if (!count) return;
      index = ((index % count) + count) % count;
      this.slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (!active) {
          var video = slide.querySelector('video');
          if (video) video.pause();
        }
      });
      this.thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      if (this.counter) this.counter.textContent = pad(index + 1);
    }

    showMedia(mediaId) {
      var index = this.slides.findIndex(function (slide) { return slide.dataset.mediaId === String(mediaId); });
      if (index >= 0) this.showSlide(index);
    }

    /* Variants */

    selectedValues() {
      return this.fieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    currentVariant() {
      if (!this.fieldsets.length) return this.product.variants[0] || null;
      var values = this.selectedValues();
      if (values.indexOf(null) !== -1) return null;
      return this.product.variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === values[i]; });
      }) || null;
    }

    onOptionChange(input) {
      var fieldset = input.closest('[data-option]');
      var label = fieldset && fieldset.querySelector('[data-option-selected]');
      if (label) label.textContent = input.value;
      this.updateAvailability();
      this.update();
    }

    /* Strike through option values that have no available variant with the current selection. */
    updateAvailability() {
      var selected = this.selectedValues();
      var variants = this.product.variants;
      this.fieldsets.forEach(function (fieldset, optionIndex) {
        $$('[data-option-input]', fieldset).forEach(function (input) {
          var available = variants.some(function (variant) {
            if (!variant.available || variant.options[optionIndex] !== input.value) return false;
            return variant.options.every(function (value, i) {
              return i === optionIndex || selected[i] === null || selected[i] === value;
            });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    setButton(label, disabled) {
      if (this.addLabel) this.addLabel.textContent = label;
      if (this.addButton) this.addButton.disabled = disabled;
    }

    update() {
      var values = this.selectedValues();
      if (values.indexOf(null) !== -1) {
        this.setButton(theme.strings.selectOptions, true);
        return;
      }

      var variant = this.currentVariant();
      if (!variant) {
        if (this.idInput) this.idInput.disabled = true;
        if (this.soldOutEl) this.soldOutEl.hidden = true;
        if (this.dynamicCheckout) this.dynamicCheckout.hidden = true;
        this.setButton(theme.strings.unavailable, true);
        return;
      }

      if (this.idInput) {
        this.idInput.value = variant.id;
        this.idInput.disabled = false;
      }

      if (this.priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceEl.innerHTML =
          '<span class="price' + (onSale ? ' price--sale' : '') + '">' +
          '<span class="price__current">' + formatMoney(variant.price, theme.moneyWithCurrencyFormat) + '</span>' +
          (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '') +
          '</span>';
      }

      if (this.soldOutEl) this.soldOutEl.hidden = variant.available;
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = !variant.available;
      this.setButton(variant.available ? theme.strings.addToCart : theme.strings.soldOut, !variant.available);

      if (variant.featured_media) this.showMedia(variant.featured_media.id);

      if (!designMode && this.dataset.productUrl) {
        window.history.replaceState({}, '', this.dataset.productUrl + '?variant=' + variant.id);
      }
    }

    onSubmit(event) {
      event.preventDefault();
      var variant = this.currentVariant();
      if (!variant) {
        toast(theme.strings.selectOptions, 'error');
        return;
      }
      if (!variant.available) {
        toast(theme.strings.soldOut, 'error');
        return;
      }

      var button = this.addButton;
      button.classList.add('is-loading');
      button.disabled = true;

      addToCart(this.form)
        .then((data) => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_ids: [this.product.id],
              content_name: this.product.title,
              content_type: 'product',
              value: variant.price / 100,
              currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
            });
          }

          button.classList.add('is-added');
          if (this.addLabel) this.addLabel.textContent = theme.strings.added;

          var drawer = getDrawer();
          if (drawer && data.sections) {
            drawer.render(data.sections['cart-drawer']);
            if (theme.openCartOnAdd) drawer.open();
            else toast(this.product.title + ' ' + theme.strings.addedToast);
          } else {
            refreshCartCount();
            toast(this.product.title + ' ' + theme.strings.addedToast);
          }

          setTimeout(() => {
            button.classList.remove('is-added');
            this.update();
          }, 1500);
        })
        .catch((error) => {
          toast(error.message, 'error');
          button.disabled = false;
        })
        .finally(function () { button.classList.remove('is-loading'); });
    }
  });

  /* ---------- Product recommendations ---------- */

  define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      var load = () => {
        fetch(this.dataset.url)
          .then(function (response) { return response.text(); })
          .then((html) => {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      };

      if (!('IntersectionObserver' in window)) return load();
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        load();
      }, { rootMargin: '0px 0px 600px 0px' });
      observer.observe(this);
    }
  });

  /* ---------- Collection sorting ---------- */

  define('sort-select', class extends HTMLElement {
    connectedCallback() {
      var select = this.querySelector('select');
      if (!select) return;
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  });

  /* ---------- Newsletter popup ---------- */

  define('newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey;
      var formId = this.dataset.formId;
      var postedHere = window.location.hash === '#' + formId;
      var postedAnywhere = window.location.search.indexOf('customer_posted=true') !== -1;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-popup-close]')) this.close();
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && !this.hidden) this.close();
      };
      document.addEventListener('keydown', this.onKeydown);

      var form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => storageSet('localStorage', this.key, '1'));

      if (this.hasAttribute('data-design-mode')) return this.open();
      if (postedAnywhere) storageSet('localStorage', this.key, '1');
      if (postedHere) return this.open();
      if (designMode) return;
      if (storageGet('sessionStorage', this.key) || storageGet('localStorage', this.key)) return;

      var delay = (Number(this.dataset.delay) || 0) * 1000;
      this.timer = setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKeydown);
    }

    open() {
      this.hidden = false;
      var input = this.querySelector('input[type="email"]');
      if (input && !designMode) setTimeout(function () { input.focus(); }, 100);
    }

    close() {
      this.hidden = true;
      storageSet('sessionStorage', this.key, '1');
    }
  });

  /* ---------- Countdown (coming soon page) ---------- */

  define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end).getTime();
      if (isNaN(this.end)) return;
      this.days = this.querySelector('[data-days]');
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() { clearInterval(this.interval); }

    tick() {
      var diff = this.end - Date.now();
      if (diff <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return;
      }
      this.hidden = false;
      this.days.textContent = pad(Math.floor(diff / 86400000));
      this.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      this.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
      this.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
  });

  /* ---------- Capsule page (door entrance + sound) ---------- */

  define('capsule-page', class extends HTMLElement {
    connectedCallback() {
      this.doors = this.querySelector('[data-doors]');
      this.muteButton = this.querySelector('[data-mute]');
      this.muted = false;

      if (this.doors) {
        document.documentElement.classList.add('scroll-lock');
        this.doors.addEventListener('click', () => this.enter());
        this.doors.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.enter();
          }
        });
      } else if (this.muteButton) {
        // No entrance click to start audio, so the sound button starts muted and plays on first click.
        this.muted = true;
        this.muteButton.hidden = false;
        this.syncMuteButton();
      }

      if (this.muteButton) this.muteButton.addEventListener('click', () => this.toggleMute());
    }

    disconnectedCallback() {
      document.documentElement.classList.remove('scroll-lock');
      [this.introAudio, this.loopAudio].forEach(function (audio) { if (audio) audio.pause(); });
    }

    enter() {
      if (this.entering) return;
      this.entering = true;
      this.doors.classList.add('is-opening');
      this.playAudio();
      setTimeout(() => {
        this.doors.remove();
        this.classList.remove('capsule--locked');
        document.documentElement.classList.remove('scroll-lock');
      }, 2500);
    }

    playAudio() {
      var intro = this.dataset.introAudio;
      var loop = this.dataset.loopAudio;
      var volume = parseFloat(this.dataset.volume) || 0.5;
      if (!intro && !loop) return;

      var startLoop = () => {
        if (!loop) return;
        this.loopAudio = new Audio(loop);
        this.loopAudio.loop = true;
        this.loopAudio.volume = volume;
        this.loopAudio.muted = this.muted;
        this.loopAudio.play().catch(function () {});
      };

      if (intro) {
        this.introAudio = new Audio(intro);
        this.introAudio.volume = volume;
        this.introAudio.muted = this.muted;
        this.introAudio.addEventListener('ended', startLoop);
        this.introAudio.addEventListener('error', startLoop);
        this.introAudio.play().catch(function () {});
      } else {
        startLoop();
      }

      if (this.muteButton) this.muteButton.hidden = false;
    }

    toggleMute() {
      if (!this.introAudio && !this.loopAudio) {
        this.muted = false;
        this.playAudio();
      } else {
        this.muted = !this.muted;
        [this.introAudio, this.loopAudio].forEach((audio) => { if (audio) audio.muted = this.muted; });
      }
      this.syncMuteButton();
    }

    syncMuteButton() {
      if (!this.muteButton) return;
      this.muteButton.classList.toggle('is-muted', this.muted);
      this.muteButton.setAttribute('aria-pressed', String(this.muted));
    }
  });

  /* ---------- Page-level setup ---------- */

  function initAddressForms() {
    if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
    $$('[data-address-country]').forEach(function (select) {
      new window.Shopify.CountryProvinceSelector(select.id, select.dataset.provinceTarget, {
        hideElement: select.dataset.provinceWrapper
      });
    });
  }

  document.addEventListener('submit', function (event) {
    var message = event.target.dataset && event.target.dataset.confirm;
    if (message && !window.confirm(message)) event.preventDefault();
  });

  function init() {
    setHeaderHeight();
    initAddressForms();
    $$('[data-open-on-error]').forEach(function (details) {
      if (details.querySelector('.form-error')) details.open = true;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', setHeaderHeight);
})();
